<template>
    <div style="width: 100%; height: 700px">
        <div style="height: 10px">
      <span
              style="float: right; position: relative"
              class="toolbarButton presentationMode"
              @click="fullScreen()"
      ></span>
        </div>
        <div :style="style" class="pdfDiv" :id="uuid">
            <PDF
                    v-for="i in pageNums"
                    :key="i"
                    :src="src"
                    :page="i"
                    style="display: block; padding: 25px 25px 25px 25px; margin-top: -20px"
                    @loaded="loadPdfHandler"
            ></PDF>
        </div>
    </div>
</template>

<script>
    import PDF from "vue-pdf";
    // import PDF from "@/components/PDF";
    import { fullScreen } from "@/utils";

    export default {
        props: {
            src: {
                type: String,
                default: "",
            },
        },
        data() {
            return {
                pageNums: 1,
                url: "",
                uuid: "pdf" + Math.floor(Math.random() * 9999999),
                style: {
                    padding: "10px",
                    height: "100%",
                    overflowY: "auto"
                },
            };
        },
        watch: {
            src(val) {
                if (val) {
                    this.url = PDF.createLoadingTask(val);
                }
            },
        },
        components: {
            PDF,
        },
        created() {
            if (this.src) {
                this.url = PDF.createLoadingTask(this.src);
            }
        },
        mounted() {
            if (this.src) {
                this.url = PDF.createLoadingTask(this.src);
                this.getPdfNum(this.src)
            }
        },
        methods: {
            getPdfNum (url) {
                let loadingTask = PDF.createLoadingTask(url)
                loadingTask.promise.then(pdf => {
                    this.pageNums = pdf.numPages
                }).catch(err => {
                    console.log(err)
                })
            },
            fullScreen() {
                const full = new fullScreen();
                full.Fullscreen("#" + this.uuid);
            },
            loadPdfHandler() {
                this.currentPage = 1; // 加载的时候先加载第一页
            },
        },
    };
</script>

